import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH } from "../Config/Config";

const deleteCapability = async (capId) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}/KeyLogging/cap/delete/${capId}`,
  );
  return response.data;
};

const useDeleteCapability = (options = {}) => {
  return useMutation({
    mutationFn: deleteCapability,
    ...options,
  });
};

export default useDeleteCapability;
